var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 16,
    fill: "#022D2D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 14.344,
    fill: "#022D2D",
    transform: "rotate(45 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 12.531,
    fill: "#022D2D",
    transform: "rotate(90 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 10.75,
    fill: "#022D2D",
    transform: "rotate(135 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 10.063,
    fill: "#022D2D",
    transform: "rotate(180 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 8.063,
    fill: "#022D2D",
    transform: "rotate(225 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 6.438,
    fill: "#022D2D",
    transform: "rotate(270 64 64)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 64,
    r: 5.375,
    fill: "#022D2D",
    transform: "rotate(315 64 64)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64",
    calcMode: "discrete",
    dur: "480ms",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageLoader);
export default __webpack_public_path__ + "static/media/page-loader.ebeda15c5df01aadfee6b3e141887fde.svg";
export { ForwardRef as ReactComponent };